import {addDays, addMinutes, startOfDay} from 'date-fns';

export function getMinimumExpiryDate(): Date {
  // Set minimum expiry date to the following day
  const minimumExpiry = startOfDay(addDays(new Date(Date.now()), 1));
  return minimumExpiry;
}

export function getMaximumExpiryDate(): Date {
  // Set maximum expiry date to 60 days from now
  const maximumExpiry = startOfDay(addDays(new Date(Date.now()), 60));
  return maximumExpiry;
}

// Converts the expiry date to UTC by adjusting for the local timezone offset
export function getOffsetExpiry(expiry: string | Date): Date {
  return addMinutes(new Date(expiry), new Date().getTimezoneOffset());
}
